import React, { useState, useEffect, useRef } from "react";
import { io } from 'socket.io-client';

const socket = io(process.env.REACT_APP_BASE_URL_NEW); // Replace with your server URL


const ChatPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]); // List of messages
  const [message, setMessage] = useState(""); // Current text input
  const [image, setImage] = useState(null); // Selected image file
  const messageListRef = useRef(null); // Ref for message list container


  useEffect(() => {
    socket.connect();

    socket.emit('join', 'userId');

    // Listen for incoming messages
    socket.on('receiveMessage', (data) => {
      

      setMessages((prev) => [...prev, data ]); 
    });

    return () => {
      socket.disconnect(); // Cleanup socket connection on unmount
    };
  },);
  // Toggle popup window visibility
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  // Handle sending a message
  const sendMessage = () => {
    if (message.trim() || image) {
      const newMessage = {
        id: Date.now(),
        text: message,
        image: image ? URL.createObjectURL(image) : null,
        sender: true, // For simplicity, the sender is always 'you'
      };

      setMessages((prevMessages) => [...prevMessages, newMessage]);
      setMessage(""); // Clear text input
      setImage(null); // Clear image
    }
  };

  // Scroll to the bottom whenever messages change
  useEffect(() => {
    if (messageListRef.current) {
      messageListRef.current.scrollTop = messageListRef.current.scrollHeight;
    }
  }, [messages]);

  // Handle file input change (image selection)
  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
    }
  };

  return (
    <div>
      {/* Toggle Chat Button */}
      <button
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          padding: "10px 15px",
          backgroundColor: "#E63946",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontWeight: "bold",
        }}
        onClick={togglePopup}
      >
        {isOpen ? "Close Chat" : "Open Chat"}
      </button>

      {/* Chat Popup Window */}
      {isOpen && (
        <div
          style={{
            position: "fixed",
            bottom: "60px",
            right: "20px",
            width: "300px",
            height: "400px",
            border: "1px solid #ddd",
            borderRadius: "8px",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: "10px",
              backgroundColor: "#E63946",
              color: "#fff",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            Chat Window
          </div>

          {/* Message List */}
          <div
            ref={messageListRef} // Ref to scrollable container
            style={{
              flex: 1,
              padding: "10px",
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            {messages.map((msg) => (
              <div
                key={msg.id}
                style={{
                  alignSelf: msg.sender ? "flex-end" : "flex-start", // Align sender to right
                  backgroundColor: msg.sender ? "#E63946" : "#f1f1f1",
                  color: msg.sender ? "#fff" : "#333",
                  padding: "8px",
                  borderRadius: "10px",
                  maxWidth: "70%",
                  wordWrap: "break-word",
                  textAlign: "left",
                }}
              >
                {msg.text && <p style={{ margin: 0 }}>{msg.text}</p>}
                {msg.image && (
                  <img
                    src={msg.image}
                    alt="Uploaded"
                    style={{
                      maxWidth: "100%",
                      borderRadius: "5px",
                      marginTop: "5px",
                    }}
                  />
                )}
              </div>
            ))}
          </div>

          {/* Input and Actions */}
          <div
            style={{
              padding: "10px",
              borderTop: "1px solid #ddd",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {/* Text Input */}
            <input
              type="text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  sendMessage();
                }
              }}
              placeholder="Type your message..."
              style={{
                flex: 3,
                padding: "5px",
                border: "1px solid #ddd",
                borderRadius: "5px",
              }}
            />

            {/* Photo Button */}
            <label
              style={{
                backgroundColor: "#E63946",
                color: "#fff",
                padding: "5px 10px",
                borderRadius: "5px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              📷
              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleImageChange}
              />
            </label>

            {/* Send Button */}
            <button
              onClick={sendMessage}
              style={{
                padding: "5px 10px",
                backgroundColor: "#E63946",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              Send
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatPopup;
